import React from 'react';

import { PhotoShootItemType } from 'apis/mips/types';

import ImagesManager from '../components/ImagesManager/ImagesManager';
import usePhotoShootContext from '../hooks/usePhotoShootContext';

const PhotoShootPage = () => {
  const { venueId, token, images, items, venueName, status } = usePhotoShootContext();

  return (
    <ImagesManager
      venueId={venueId}
      token={token}
      images={images || []}
      items={
        items || {
          [PhotoShootItemType.MENU_ITEM]: [],
          [PhotoShootItemType.HEADER]: [],
          [PhotoShootItemType.LIST]: [],
        }
      }
      venueName={venueName}
      status={status}
    />
  );
};

export default PhotoShootPage;
